import { SVGProps } from 'react'

const InfoIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='12' height='11' viewBox='0 0 12 11' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <g clipPath='url(#clip0_228_3210)'>
                <path
                    d='M5.7502 10.0837C8.28151 10.0837 10.3335 8.03163 10.3335 5.50033C10.3335 2.96902 8.28151 0.916992 5.7502 0.916992C3.2189 0.916992 1.16687 2.96902 1.16687 5.50033C1.16687 8.03163 3.2189 10.0837 5.7502 10.0837Z'
                    stroke='currentColor'
                    strokeWidth='0.85119'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M5.75 7.33333V5.5'
                    stroke='currentColor'
                    strokeWidth='0.85119'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M5.75 3.66699H5.75426'
                    stroke='currentColor'
                    strokeWidth='0.85119'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_228_3210'>
                    <rect width='11' height='11' fill='white' transform='translate(0.25)' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default InfoIcon
